module.exports = __webpack_public_path__ + "img/schema.43f60a22.svg";